module.exports = __webpack_public_path__ + "Lato-Italic.4ffc48d0549568bb624b.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-Italic.ttf
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-Italic.ttf
// module chunks = styles